import React, { FunctionComponent as FC, useRef, useState, useEffect } from 'react';
import './index.scss';
import _ from 'lodash';

import { GlobalStyle } from '../../../../../types/style.d';
import { themeColor, caseMark } from '../../../../../types/style.global';
import { PIViewTypes } from '../../../../../types/data';
import {HomeFilled, PhoneFilled, MailFilled } from '@ant-design/icons';

import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';


interface PICard {
  viewParam: GlobalStyle.ViewSize;
  PIStatisticsData: PIViewTypes.PIStatisticsUnit
  // boxShadowStyle: string;
  // divOutlineColor: string;
}

const PICard: FC<PICard> = (props) => {

  const { viewParam, PIStatisticsData } = props

  // State for window width and responsive avatar size
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [avatarSize, setAvatarSize] = useState(70);

  // Window resize listener
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Calculate responsive avatar size based on window width
  useEffect(() => {
    // Responsive avatar size calculation
    // Base size is 90px for large screens (>1200px)
    // Scale down proportionally for smaller screens
    let calculatedSize;
    if (windowWidth >= 1200) {
      calculatedSize = 70;
    } else if (windowWidth >= 768) {
      calculatedSize = Math.max(40, Math.floor(windowWidth * 0.075)); // 60-90px range
    } else if (windowWidth >= 480) {
      calculatedSize = Math.max(30, Math.floor(windowWidth * 0.094)); // 45-60px range
    } else {
      calculatedSize = Math.max(20, Math.floor(windowWidth * 0.104)); // 35-50px range
    }

    setAvatarSize(calculatedSize);
  }, [windowWidth]);

  // case 1: NIH
  const nameColor: string = PIStatisticsData.demographicInfo.isInSubInstitute === true ? themeColor.defaultMode.piCardColorSubInstituion : themeColor.defaultMode.piCardColorNotSubInstituion
  const weblink: string = `https://app.dimensions.ai/details/entities/publication/author/${PIStatisticsData.researcherID}`;

  // get avatar image
  let avatarSrc = null;
  // try {
  //   // 修改researcherID的格式，将所有的"."替换为"_"
  //   const formattedResearcherID = PIStatisticsData.researcherID.replace(/\./g, '_');
  //   // 使用require引入图片
  //   avatarSrc = require(`../../../../../../public/avatar/${formattedResearcherID}.png`);
  // } catch (e) {
  //   // 如果文件不存在，则使用默认值
  //   avatarSrc = null;
  // }

  // case 1: NIH
  return (
    <div className='PICardDiv'
        style={{
          // width: viewParam.width,
          height: 'auto', // viewParam.height,
          // marginTop: "20px",
          // marginBottom: "20px",
          // marginLeft: "2px",
          // marginRight: "2px"
        }}
        // onClick={()=>handleOnClickPICard()}
      >
        <div className='card-avatar-and-text-info'>
          <div className='cardAvatar'>
              <Avatar size={avatarSize} src={avatarSrc} style={{backgroundColor: "#ab9587", opacity: 0.7}}>
                <UserOutlined style={{fontSize: avatarSize / 2, color:"#ffffff"}} />
              </Avatar>
              <div className='cardGender'>
                  {"("+PIStatisticsData.demographicInfo['gender']+", "+PIStatisticsData.demographicInfo['ethnicity']+")"}
              </div>
          </div>
          <div className='cardText'>
              <div className='cardName1' style={{color: nameColor}}>
                  {PIStatisticsData.demographicInfo['fullName']}
              </div>
              <div className='cardOrganizationName'>
                  {PIStatisticsData.demographicInfo['organizationName']}
              </div>
              <div className='metric cardCareerAge'>
                  Career Age: {
                    PIStatisticsData.demographicInfo['careerAge'] <= 10 ?
                    `junior (${PIStatisticsData.demographicInfo['careerAge']} years)` :
                    PIStatisticsData.demographicInfo['careerAge'] <= 30 ?
                    `middle (${PIStatisticsData.demographicInfo['careerAge']} years)` :
                    `senior (${PIStatisticsData.demographicInfo['careerAge']} years)`
                  }
              </div>
              <div className='metric cardHIndex'>
                  H-Index: {PIStatisticsData.scisciIndex['hIndex']}
              </div>
              <div className='metric cardProductivity'>
                  Productivity: {PIStatisticsData.scisciIndex['productivity']}
              </div>
              <div className='metric cardTotalPublications'>
                  Total Publications: {PIStatisticsData.scisciIndex['totalPublications']}
              </div>
              <div className='metric cardTotalGrants'>
                  Total Grants: {PIStatisticsData.scisciIndex['totalGrants']}
              </div>
              {/* <div className='metric cardPScore'>
                  Prediction Score: {PIStatisticsData.scisciIndex['pScore'].toFixed(3)}
              </div> */}
          </div>
        </div>
        <div className='card-detail-info'>
          <div className='cardDetail'>
              <div className='cardDetailText'>
                <a href={weblink} target="_blank" onClick={(event) => event.stopPropagation()}>
                  Details
                </a>
              </div>
              {/* <div className='cardDetailLine'></div> */}
              <div className='cardDetailIconList'>
                <div className='cardDetailIcon1'><HomeFilled style={{fontSize: "16px", color:"#00000070"}}/></div>
                <div className='cardDetailIcon2'><PhoneFilled style={{fontSize: "16px", color:"#00000070"}} /></div>
                <div className='cardDetailIcon3'><MailFilled style={{fontSize: "16px", color:"#00000070"}} /></div>
              </div>
          </div>
        </div>
      </div>
  )
}


export default PICard;